import { useEffect, useCallback } from 'react';
import './style.scoped.css';
import Loading from 'src/components/Loading';
import usePullToRefresh from 'src/hooks/usePullToRefresh';
import NewsItem from 'src/components/NewsItem';
import NewsModel from 'src/models/News';
import { PAGE_SIZE } from 'src/constants';
import homeStore, { HomeStore } from 'src/stores/HomeStore';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

const loadingComponent = <Loading type={'small'} />;
interface NewsObserverProps {
  store?: HomeStore;
}

const NewsObserver = observer(({ store }: NewsObserverProps) => {
  const { t } = useTranslation();
  const _load = useCallback(
    (pageNumber: number = 1) => {
      store.fetchAllNews(pageNumber);
    },
    [store]
  );

  // Add pull to refresh function
  usePullToRefresh('.refreshContent', loadingComponent, _load);
  const allNewsList = store?.allNews?.list || [];
  useEffect(() => {
    _load(1);
  }, [_load]);

  const _loadMore = () => {
    if (!store.allNews || !store.allNews?.count || store.loadingMoreAllNews)
      return;
    const totalPage = Math.ceil(store.allNews?.count / PAGE_SIZE);
    if (store.allNews.pageNumber >= totalPage) return;
    _load(store.allNews.pageNumber + 1);
  };

  const _renderItem = (item: NewsModel, index) => {
    return (
      <div
        key={item.id}
        className={index < allNewsList.length - 1 ? 'mb-4' : ''}
      >
        <NewsItem data={item} />
      </div>
    );
  };

  const _handleScroll = (e) => {
    const target = e.target;
    if (
      Math.abs(target.scrollHeight - target.scrollTop - target.clientHeight) <
      45
    ) {
      _loadMore();
    }
  };

  return (
    <div className="roundContent">
      <div
        className="screenScrollContainerWithTab refreshContent"
        onScroll={_handleScroll}
      >
        {store.loadingAllNews ? (
          <Loading type={'small'} />
        ) : !allNewsList || allNewsList.length == 0 ? (
          <div className="center p-4 pt-8">
            <div className="text-center text-onSurfaceVariant">
              {t('no_news')}
            </div>
          </div>
        ) : (
          allNewsList.map(_renderItem)
        )}
        {store.loadingMoreAllNews && <Loading type={'small'} />}
      </div>
    </div>
  );
});

const News = () => <NewsObserver store={homeStore} />;
export default News;
